import React, { createContext, FC, useState } from 'react'

export interface IFrameContextRefs {
  sidebarPaneContainer: any
  headerTitleContainer: any
  contentTopHeaderContainer: any
  headerRefreshContainer: any
  headerPrimaryActionContainer: any
  headerSharedToolsContainer: any
  topHeaderActionContainer: any
}
export interface IFullFrameContext extends IFrameContextRefs {
  setFrameContainerRef: (payload: Partial<IFrameContextRefs>) => void
}

export const FrameContext = createContext({
  setFrameContainerRef: (payload) => {},
  sidebarPaneContainer: null,
  headerTitleContainer: null,
  contentTopHeaderContainer: null,
  headerRefreshContainer: null,
  headerPrimaryActionContainer: null,
  headerSharedToolsContainer: null,
  topHeaderActionContainer: null,
})

export default FrameContext
